import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { api } from "./lib/api";
import { ScrollToTop } from "./components/ScrollToTop";
import { Toaster } from "sonner";
import "./i18n";
import { setLang, useLang } from "./i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ModalsProvider } from "./context/ModalsContext";
import { PrivacyOverlay } from "./components/PrivacyOverlay";
import { PendingAppointments } from "./components/PendingAppointments";
import Calendario from "./pages/Calendario";
import Alertas from "./pages/Alertas";
import Ranking from "./pages/Ranking";
import Mapa from "./pages/Mapa";
import Acerca from "./pages/Acerca";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import Bloqueo from "./pages/Bloqueo";
import Inicio from "./pages/Inicio";
import Personas from "./pages/Personas";
import PersonaForm from "./pages/PersonaForm";
import PersonaDetalle from "./pages/PersonaDetalle";
import Ajustes from "./pages/Ajustes";

const Loading = () => (
  <div className="min-h-[100dvh] flex items-center justify-center">
    <span className="w-10 h-10 rounded-full border-[3px] border-[#d4af37] border-t-transparent animate-spin" />
  </div>
);

function Protected({ children }) {
  const { user, unlocked } = useAuth();
  const location = useLocation();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!unlocked) return <Bloqueo />;
  return <ModalsProvider><PendingAppointments />{children}</ModalsProvider>;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (user) return <Navigate to="/bloqueo" replace />;
  return children;
}

function LockRoute() {
  const { user, unlocked } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (unlocked) return <Navigate to="/" replace />;
  return <Bloqueo />;
}

function LangSync() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    const pending = localStorage.getItem("circulo_lang_pending");
    if (pending) { localStorage.removeItem("circulo_lang_pending"); setLang(pending); api.put("/auth/settings", { idioma: pending }).catch(() => {}); return; }
    if (user.settings?.idioma) setLang(user.settings.idioma);
  }, [user]);
  return null;
}

export default function App() {
  const lng = useLang();
  return (
    <BrowserRouter>
      <AuthProvider>
        <LangSync />
        <ScrollToTop />
        <PrivacyOverlay />
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#1d212a", border: "1px solid #232833", color: "#f1f5f9" } }} />
        <Routes key={lng}>
          <Route path="/login" element={<Public><Login /></Public>} />
          <Route path="/registro" element={<Public><Registro /></Public>} />
          <Route path="/bloqueo" element={<LockRoute />} />
          <Route path="/" element={<Protected><Inicio /></Protected>} />
          <Route path="/personas" element={<Protected><Personas /></Protected>} />
          <Route path="/personas/nueva" element={<Protected><PersonaForm /></Protected>} />
          <Route path="/personas/:id" element={<Protected><PersonaDetalle /></Protected>} />
          <Route path="/personas/:id/editar" element={<Protected><PersonaForm /></Protected>} />
          <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
          <Route path="/ranking" element={<Protected><Ranking /></Protected>} />
          <Route path="/alertas" element={<Protected><Alertas /></Protected>} />
          <Route path="/mapa" element={<Protected><Mapa /></Protected>} />
          <Route path="/acerca" element={<Protected><Acerca /></Protected>} />
          <Route path="/ajustes" element={<Protected><Ajustes /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
